import { getSchedulePageData } from "../api"
import { toastError, toastWarn } from "../../global/errors.toast";
import {
    GET_SchedulePage_REQUEST,
    GET_SchedulePage_SUCCESS,
    GET_SchedulePage_FAILURE,
} from "../const";


const request = () => ({ type: GET_SchedulePage_REQUEST });

const success = (SchedulePage) => ({
    type: GET_SchedulePage_SUCCESS,
    payload: { SchedulePage },
});
const failure = () => ({ type: GET_SchedulePage_FAILURE });

export const receiveSchedulePage = (params) => async (dispatch) => {
    dispatch(request());
    try {
        getSchedulePageData(params).then(({ data: receiveSchedulePageData }) => {
            dispatch(success(receiveSchedulePageData ));
        }).catch((error) => {
            if (error.response.status === 400) {
                toastWarn(`${error.response.status} Bad request`)
            } else {
                if (error.response.status === 500) {
                    toastError(`${error.response.status} Server error`)
                }
            }
        })
    } catch (e) {
        dispatch(failure());
    };
};

